import { Route, Switch, Redirect } from "react-router-dom";
import { useContext } from "react";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
import { URL_ID } from "constants/constants.js";

// public pages
import Shop from "../shop/Shop";
import Tours from "../tours/Tours";
import Home from "../home/Home";
import ReserveTour from "../reserve_tour/ReserveTour";
import TakTour from "../taktour/index.jsx";
import TourList from "../admin-panel/tour-list/TourList";
import PayTrack from "pay_track/PayTrack";

import AboutUs from "about-us/AboutUs";
import Condition from "condition/Condition";
import Connection from "connection-with-us/Connection";

import Attractions from "../Attractions/Attractions";

// admin panel
import CampainManagement from "../admin-panel/campain-management/CampainManagement";
import ClueManagement from "../admin-panel/clue-management/ClueManagement";
import Management from "../admin-panel/management/Management";
import FinancialDepartment from "../admin-panel/financial-department/index";
import AdminLayout from "../admin-panel/Layout";
import AdminReservation from "../admin-panel/reservation/index";
import Lists from "admin-panel/reservation/Lists";
import UserManagement from "../admin-panel/user_management/UserManagement";
import UserReport from "../admin-panel/user_report/UserReport";
import TabsPage from "../admin-panel/create-tours/tabsPage/TabsPage";

// customer panel
import CustomerPanelLayout from "../customer-panel/Layout";
import CustomerProfile from "../customer-panel/customer-profile/CustomerProfile";
import CustomerPanel from "../customer-panel/customer-panel/CustomerPanel";
import Transactions from "../customer-panel/Transaction/Transactions";
import Orders from "../customer-panel/Order/Orders";

// only in development
import AllPages from "../all-pages/AllPages";
import Test from "all-pages/test";
import SingleTour from "single-tour/SingleTour";

export default function Routes() {
  const auth = useContext(AuthenticationContext);
  const showRoute = (component, id) => {
    if (auth.userInfo.accessLevel.includes(id) && !auth.userInfo.isFirst) {
      return component;
    } else if (!auth.userInfo.isFirst) {
      return <Redirect to="/" />;
    } else {
      return "";
    }
  };
  return (
    <>
      <Switch>
        <Route path="/" exact component={Home}></Route>
        <Route path="/shop" exact component={Shop}></Route>
        <Route path="/tours" exact component={Tours}></Route>
        <Route path="/pay-track/:id" exact component={PayTrack}></Route>
        <Route path="/reserve-tour/:id" exact component={ReserveTour}></Route>
        <Route path="/single-tour/:tourId" exact component={SingleTour}></Route>
        <Route path="/tak-tour/:tourId" exact component={TakTour}></Route>

        <Route
          path="/admin-panel/tour-list"
          render={() => {
            return showRoute(<TourList />, URL_ID.customerProfile.id);
          }}
          exact
        ></Route>

        <Route path="/attractions" exact component={Attractions}></Route>
        <Route path="/admin-panel/campain-management" exact component={CampainManagement}></Route>
        <Route path="/admin-panel/clue-management" exact component={ClueManagement}></Route>
        <Route path="/about-us" exact component={AboutUs}></Route>
        <Route path="/tour-condition" exact component={Condition}></Route>
        <Route path="/connection-us" exact component={Connection}></Route>

        <Route path={["/customer-panel/dashboard", "/customer-panel/profile", "/customer-panel/transactions", "/customer-panel/orders"]}>
          <CustomerPanelLayout>
            <Route
              path="/customer-panel/profile"
              exact
              render={() => {
                return showRoute(<CustomerProfile />, URL_ID.customerProfile.id);
              }}
            ></Route>
            <Route
              path="/customer-panel/dashboard"
              exact
              render={() => {
                return showRoute(<CustomerPanel />, URL_ID.customerDashboard.id);
              }}
            ></Route>
            <Route
              path="/customer-panel/transactions"
              exact
              render={() => {
                return showRoute(<Transactions />, URL_ID.customerTransactions.id);
              }}
            ></Route>
            <Route
              path="/customer-panel/orders"
              exact
              render={() => {
                return showRoute(<Orders />, URL_ID.customerOrders.id);
              }}
            ></Route>
          </CustomerPanelLayout>
        </Route>

        <Route
          path="/admin-panel/create-tour/:tour_id?"
          exact
          render={() => {
            return showRoute(<TabsPage />, URL_ID.adminCreateTour.id);
          }}
        ></Route>

        <Route path={["/admin-panel/user-management", "/admin-panel/user-report/:edit_key", "/admin-panel/management", "/admin-panel/reservation", "/admin-panel/financial-department"]}>
          <AdminLayout>
            <Route
              path="/admin-panel/user-management"
              exact
              render={() => {
                return showRoute(<UserManagement />, URL_ID.adminUserManagement.id);
              }}
            ></Route>
            <Route
              path="/admin-panel/user-report/:userId"
              exact
              render={() => {
                return showRoute(<UserReport />, URL_ID.adminUserReport.id);
              }}
            ></Route>

            <Route
              path="/admin-panel/management"
              exact
              render={() => {
                return showRoute(<Management />, URL_ID.adminManagement.id);
              }}
            ></Route>
            <Route
              path="/admin-panel/financial-department"
              exact
              render={() => {
                return showRoute(<FinancialDepartment />, URL_ID.adminFinancial.id);
              }}
            ></Route>
            <Route
              path="/admin-panel/reservation"
              exact
              render={() => {
                return showRoute(<AdminReservation />, URL_ID.adminReservation.id);
              }}
            ></Route>
            <Route
              path="/admin-panel/reservation/lists/:type/:id"
              exact
              render={() => {
                return showRoute(<Lists />, URL_ID.adminReservation.id);
              }}
            ></Route>
          </AdminLayout>
        </Route>
        <Route path="/all-pages" exact component={AllPages}></Route>
        <Route path="/testing" exact component={Test}></Route>
        <Route path="/list" exact component={AllPages}></Route>
      </Switch>
    </>
  );
}
